import { getSelectedThemeName, getThemeMeta } from "./themeMeta";
import { getHomepageContent } from "./content/homepageContent";

let _cachedThemeConfig;

function assertNonEmptyString(value, path, themeName) {
  if (typeof value !== "string" || value.trim() === "") {
    throw new Error(
      `[theme:${themeName}] Missing/invalid required field: ${path} (expected non-empty string)`
    );
  }
}

function validateThemeMeta(meta, themeName) {
  const hero = meta?.homeHero;
  if (!hero) {
    throw new Error(`[theme:${themeName}] Missing required field: meta.homeHero`);
  }

  const kind = hero?.kind;
  if (kind !== "video" && kind !== "image") {
    throw new Error(
      `[theme:${themeName}] Invalid meta.homeHero.kind: ${String(
        kind
      )} (expected "video" or "image")`
    );
  }

  assertNonEmptyString(hero?.src, "meta.homeHero.src", themeName);

  // Poster is optional, but if provided it must be a non-empty string.
  if (hero?.poster !== undefined && hero?.poster !== null) {
    assertNonEmptyString(hero?.poster, "meta.homeHero.poster", themeName);
  }
}

function validateHomepageContent(content, themeName) {
  // Critical: hero CTA label must always exist (homepage CTA button).
  assertNonEmptyString(content?.hero?.ctaLabel, "homepage.hero.ctaLabel", themeName);
}

function buildThemeConfig(themeName) {
  const meta = getThemeMeta(themeName);
  const homepage = getHomepageContent(themeName);

  validateThemeMeta(meta, themeName);
  validateHomepageContent(homepage, themeName);

  return { name: themeName, meta, homepage };
}

/**
 * Single entry point for all theme-dependent config (tokens are still driven by CSS variables).
 *
 * This is cached for the session because VITE_THEME is build-time fixed.
 */
export function getThemeConfig(themeName = getSelectedThemeName()) {
  if (_cachedThemeConfig && _cachedThemeConfig.name === themeName) return _cachedThemeConfig;
  _cachedThemeConfig = buildThemeConfig(themeName);
  return _cachedThemeConfig;
}


